module.exports = __webpack_public_path__ + "img/framee01.fecca06f.jpg";